<template>
  <div>
    <div class="text-center">
      <div class="wwi-header--title">
        Herzlich Willkommen im <img src="/wwi-images/logo.svg">-Kurs
      </div>
      <p
        class="wwi-header--intro"
        v-html="$t('pages.start.description')"
      />
    </div>
    <div class="www-start--product-list">
      <product
        v-for="(product, index) in products"
        :key="index"
        :product="product"
        @order="$router.push('email')"
      />
    </div>
  </div>
</template>

<script>
import Product from '../components/pages/start/Product.vue'

export default {
  components: {
    Product
  },
  computed: {
    products () {
      return this.$store.getters['products/products']
    }
  },
  mounted: function () {
    this.$store.dispatch('products/GetProducts')
  }
}
</script>

<style scoped>
.www-start--product-list {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
}
</style>
